document.addEventListener("DOMContentLoaded", function () {

  var slider = document.querySelector('[data-top-bar-slider]');
  if (!slider) return;

  var flkty = null;
  var requestId;

  function showItems() {
    slider.querySelectorAll('.top-bar__item').forEach(function (el) {
      el.style.display = 'block';
    });
  }

  function hideItems() {
    slider.querySelectorAll('.top-bar__item').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function play(speed) {
    function animate() {
      flkty.x -= speed;
      flkty.settle(flkty.x);
      requestId = requestAnimationFrame(animate);
    }
    animate();
  }

  function pause() {
    if (requestId) {
      cancelAnimationFrame(requestId);
      requestId = undefined;
    }
  }

  function initSlider() {

    if (window.innerWidth <= 1243) {

      if (flkty) return;

      showItems();

      flkty = new Flickity(slider, {
        accessibility: true,
        resize: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        percentPosition: true,
        setGallerySize: true,
        cellSelector: '.top-bar__item',
        cellAlign: 'left',
        draggable: false
      });

      var speed = window.innerWidth <= 768 ? 1.2 : 1.2;

      flkty.x = 0;

      slider.addEventListener("mouseenter", pause);
      slider.addEventListener("mouseleave", function () {
        play(speed);
      });

      play(speed);

    } else {

      if (flkty) {
        pause();
        flkty.destroy();
        flkty = null;
      }

    //   hideItems();
    }
  }

  initSlider();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initSlider();
    }, 200);
  });

});